require('@babel/polyfill');
require('intersection-observer');
require('url-search-params-polyfill');
window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

require('../../../static/default/lib/jquery.sticky-kit.min.js');

$(document).ready(function () {
    processInclude(require('org/components/spinner'));
    processInclude(require('./components/header'));
    processInclude(require('./components/menu'));
    processInclude(require('org/components/countrySelector'));
    processInclude(require('base/components/cookie'));
    processInclude(require('org/components/consentTracking'));
    processInclude(require('org/components/footer'));
    processInclude(require('./components/footer'));
    processInclude(require('org/components/backtotop'));
    processInclude(require('org/components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('org/components/search'));
    processInclude(require('org/product/quickView'));
    processInclude(require('org/components/clientSideValidation'));
    processInclude(require('org/components/carousels'));
    processInclude(require('org/components/vhFix'));
    processInclude(require('org/components/toolTip'));
    processInclude(require('org/components/promoDrawer'));
    processInclude(require('org/components/fyl'));
    processInclude(require('org/components/videoAutoplay'));
});

require('org/thirdParty/bootstrap');
require('svg4everybody')();
require('slick-carousel');
require('picturefill');
require('lazysizes');
